import React from 'react';
import TableHeaderAddRow from '@/components/table/TableHeaderAddRow';
import CollectionDatasetsDropdown from './CollectionDatasetsDropdown';

const CollectionDatasetsAssignAddRow = ({
  readStatus,
  filter,
  datasets,
  datasetsToAdd,
  datasetsToAddChange,
  onFilterChange,
  addDatasets,
}) => (
  <TableHeaderAddRow
    entity="collection.dataset"
    disabled={datasetsToAdd.length === 0}
    onClick={addDatasets}
    colSpan={2}
  >
    <CollectionDatasetsDropdown
      datasets={datasets}
      autoFocus
      onChange={datasetsToAddChange}
      onFilterChange={onFilterChange}
      readStatus={readStatus}
      filter={filter}
      text={datasetsToAdd.map((dataset) => dataset.code)}
    />
  </TableHeaderAddRow>
);

export default CollectionDatasetsAssignAddRow;
